import { CORE, gateway } from '../../api';

export function salvarPreferenciaInspecaoUsuarioService(idPreferenciaInspecao) {
  return gateway.post(`${CORE}/preferencia-inspecao-usuario/${idPreferenciaInspecao}`);
}

export function deletarPreferenciaInspecaoUsuarioService(idPreferenciaInspecao) {
  return gateway.delete(`${CORE}/preferencia-inspecao-usuario/${idPreferenciaInspecao}`);
}
